module.exports = __webpack_public_path__ + "media/images/simulation/ic_share-70c99ad6bb881d3ff23531037894182a.svg";